// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/main/web/4072/js/" + chunkId + ".chunk.js";
};